import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-499e5046"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "provision_title" }, "利用規約", -1))
const _hoisted_2 = { class: "provision_layout" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "転職支援サービス利用規約"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "provision_layout_value"
}
const _hoisted_5 = { class: "provision_layout" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "個人情報の取り扱いについて"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "provision_layout_value"
}
const _hoisted_8 = { class: "provision_layout" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "取扱職種の範囲等について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "provision_layout_value"
}
const _hoisted_11 = { class: "provision_layout" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "入力情報・作成書類について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "provision_layout_value"
}
const _hoisted_14 = { class: "provision_layout" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "登録データの開示について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_16 = {
  key: 0,
  class: "provision_layout_value"
}
const _hoisted_17 = {
  key: 1,
  class: "provision_layout_value"
}
const _hoisted_18 = {
  key: 0,
  class: "provision_layout"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "転職希望時期について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_20 = { class: "provision_layout_value" }
const _hoisted_21 = { class: "provision_layout" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "企業との面接日時について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_optional" }, "任意")
], -1))
const _hoisted_23 = { class: "provision_layout_value" }
const _hoisted_24 = { class: "provision_layout" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "マスメディアンからのご連絡について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_optional" }, "任意")
], -1))
const _hoisted_26 = { class: "provision_layout_value" }

import { PropType,computed } from 'vue';
import { useStore } from 'vuex';

type Provision = {
  consentFlg1?: boolean;
  consentFlg2?: boolean;
  consentFlg3?: boolean;
  consentFlg4?: boolean;
  lastChargeFlg?: boolean;
  aboutDateInterview?: string;
  aboutCommunicationMedia?: string;
  wishJobChangeDateId?: number;
  wishJobChangeDateDisplayFlg?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvisionConfirm',
  props: {
    provision: null,
    changeDateConvert: null
  },
  setup(__props: any) {

const props = __props as {
  provision: Provision;
  changeDateConvert: { label: string; value: string }[];
}



const selectedChangeDateValueName = computed(() => {
  if (!props.changeDateConvert || !Array.isArray(props.changeDateConvert)) {
    return '';
  }
  const match = props.changeDateConvert.find(
    (item) => item.value === String(props.provision.wishJobChangeDateId)
  );
  return match?.label ?? '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (props.provision.consentFlg1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "同意する"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (props.provision.consentFlg2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "同意する"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (props.provision.consentFlg4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "同意する"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      (props.provision.consentFlg3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "同意する"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      (props.provision.lastChargeFlg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, "はい"))
        : _createCommentVNode("", true),
      (!props.provision.lastChargeFlg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "いいえ"))
        : _createCommentVNode("", true)
    ]),
    (props.provision.wishJobChangeDateDisplayFlg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(selectedChangeDateValueName)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, _toDisplayString(props.provision.aboutDateInterview), 1)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, _toDisplayString(props.provision.aboutCommunicationMedia), 1)
    ])
  ], 64))
}
}

})